import departmentApi from '../../api/rest/departmentApi';
import {setAlert} from '../actions/alertModalStateAction';
import {setDepartments} from '../actions/departmentAction';
import {EResponseCode, ALERT_VARIANT} from '../../const/dataEnum';

const fetchDepartments =
  (isGetAllDept = false) =>
  async (dispatch) => {
    try {
      const res = await departmentApi.fetchDepartments(isGetAllDept);

      if (!res) {
        dispatch(setAlert({show: true, variant: ALERT_VARIANT.ERROR, message: 'Failed to fetch departments'}));
        return;
      }

      const {data, responseCode, message} = res;

      if (responseCode === EResponseCode.NO_ERROR) {
        const formatted = data.map((dept) => ({
          id: dept.id,
          text: dept.departmentName,
          group: '',
          data: dept,
        }));
        dispatch(setDepartments(formatted));
      } else if (responseCode < -1) {
        dispatch(setAlert({show: true, variant: ALERT_VARIANT.ERROR, message}));
      }
    } catch (err) {
      dispatch(setAlert({show: true, variant: ALERT_VARIANT.ERROR, message: 'Failed to fetch departments'}));
    }
  };

const getAllDepartment = (userAuthRoleId) => async (dispatch) => {
  const data = await departmentApi.getAllDepartment(userAuthRoleId);
  dispatch(setDepartments(data));
  return data;
};

const getDepartment = async (dispatch) => {
  const data = await departmentApi.getAllDepartment();
  dispatch(setDepartments(data));
  return data;
};

const updateDepartment = (department) => async (dispatch) => {
  const data = await departmentApi.updateDepartment(department);
  if (data.responseCode === 0) {
    dispatch(
      setAlert({
        show: true,
        variant: ALERT_VARIANT.SUCCESS,
        message: data.message,
      })
    );
  } else {
    dispatch(
      setAlert({
        show: true,
        variant: ALERT_VARIANT.ERROR,
        message: data.message,
      })
    );
  }
};

const getDepartmentById = (departments, departmentId) => {
  const department = departments.find((department) => department.id === departmentId);
  return department;
};

export const departmentBusiness = {
  fetchDepartments,
  getAllDepartment,
  updateDepartment,
  getDepartmentById,
  getDepartment,
};
